<header class="bg-white">
  <div class="flex justify-between py-4 lg:py-6 items-center gap-3 md:gap-4">
    <div class="flex gap-6 items-center shrink-0">
      <a class="cursor-pointer" (click)="logoClick.emit()">
        @if (showDefaultLogo() || unrecognizedLogo()) {
          <img src="assets/cpit-logo.svg" alt="cpit Logo" />
        } @else if (logoSrc()) {
          <img
            class="w-32 h-8 md:w-40 md:h-10 object-contain object-left"
            [src]="logoSrc()"
            alt="Vermitler logo"
          />
        } @else {
          <mat-progress-spinner [diameter]="30" mode="indeterminate" color="accent" />
        }
      </a>
      @if (title()) {
        <div class="hidden md:flex">|</div>
        <div class="hidden md:flex text-base font-normal">{{ title() }}</div>
      }
    </div>

    <div class="flex items-center gap-4 shrink-0 ml-auto lg:ml-0">
      @if (firstRowStepInfo(); as info) {
        <div class="md:hidden text-base font-bold">{{ info }}</div>
      }
      <span [class]="accessibleModeLabelClass()"
        >Barrierefreiheitsmodus
        <a href="" class="ml-2" (click)="toggleAccessibleMode(); $event.preventDefault()">
          {{ isAccessibleMode() ? 'an' : 'aus' }}
        </a>
      </span>
      <button
        type="button"
        class="flex"
        aria-label="Barrierefreiheitsmodus"
        [attr.aria-pressed]="isAccessibleMode()"
        (click)="toggleAccessibleMode()"
      >
        <mat-icon svgIcon="cp-contrast" class="!w-8 !h-8 md:!w-9 md:!h-9" />
      </button>
    </div>

    @if (showPoweredByCpit()) {
      <div class="hidden lg:flex gap-6 items-center">
        <div class="text-xs">powered by cpit</div>
        <div>
          <img src="assets/cpit.svg" alt="powered-by-cpit-logo" />
        </div>
      </div>
    }

    @if (brandExtra() || brandSecondary()) {
      <div class="flex items-center gap-4 min-w-0">
        @if (brandSecondary(); as secondary) {
          <div class="hidden lg:flex shrink-0">
            <ng-container *ngComponentOutlet="secondary" />
          </div>
        }
        @if (brandExtra(); as extra) {
          <ng-container *ngComponentOutlet="extra" />
        }
      </div>
    }
  </div>

  @if (brandSecondary(); as secondary) {
    <div
      data-testid="header-step-row"
      class="flex lg:hidden items-center justify-between gap-4 -mx-3 px-3 border-t md:border-t-0 md:has-[>div>:not(:empty)]:border-t border-cp-primary-20"
    >
      @if (stepInfo(); as info) {
        <div class="md:hidden py-3 text-sm font-bold">{{ info }}</div>
      }
      <div class="ml-auto">
        <ng-container *ngComponentOutlet="secondary" />
      </div>
    </div>
  }
</header>
